import axios from "axios";

export async function downloadReport(url, params) {
  var prefixUrl;
  if (url) prefixUrl = url;
  else
    prefixUrl = `${process.env.REACT_APP_API_URL}/api/online/v1/lead-status-report`;

  try {
    const response = await axios.get(`${prefixUrl}`, {
      responseType: "blob",
      params: params,
      headers: {
        Authorization:
          "Bearer " + JSON.parse(localStorage.getItem("currUserToken")),
      },
    });

    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement("a");

    const fileName = `sample_Report.xlsx`;

    link.href = url;
    link.setAttribute("download", fileName);
    document.body.appendChild(link);
    link.click();

    return { error: null };
  } catch (error) {
    return { error };
  }
}
